import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./AuthSlice";

import { errorSlice } from "./error.slice";

const rootReducer = combineReducers({
  auth: authSlice.reducer,
    error: errorSlice.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
